var map = {
	"./pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"default~pages-login-login-module~pages-payment-success-payment-success-module~pages-preadmissionform~b2c54203",
		"default~pages-login-login-module~pages-preadmissionform-preadmissionform-module",
		"common",
		"pages-login-login-module"
	],
	"./pages/payment-success/payment-success.module": [
		"./src/app/pages/payment-success/payment-success.module.ts",
		"default~pages-login-login-module~pages-payment-success-payment-success-module~pages-preadmissionform~b2c54203",
		"common",
		"pages-payment-success-payment-success-module"
	],
	"./pages/preadmissionform/preadmissionform.module": [
		"./src/app/pages/preadmissionform/preadmissionform.module.ts",
		"default~pages-login-login-module~pages-payment-success-payment-success-module~pages-preadmissionform~b2c54203",
		"default~pages-login-login-module~pages-preadmissionform-preadmissionform-module",
		"common",
		"pages-preadmissionform-preadmissionform-module"
	],
	"./pages/preadmissionlist/preadmissionlist.module": [
		"./src/app/pages/preadmissionlist/preadmissionlist.module.ts",
		"default~pages-login-login-module~pages-payment-success-payment-success-module~pages-preadmissionform~b2c54203",
		"common",
		"pages-preadmissionlist-preadmissionlist-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;